import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
  ViewChild,
  EventEmitter,
  Output,
  HostListener,
  DOCUMENT
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from '../../../services/core/user.service';

import { MatMenuTrigger } from '@angular/material/menu';
import { JsonService } from '../../../services/core/json.service';
import { AuthDataService } from '../../auth/services/auth.data.service';
import { finalize, first, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter, Subscription, Observable } from 'rxjs';
import { DialogService } from 'src/app/services/core/dialog.service';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
//import { ChangePasswordComponent } from './change-password/change-password.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StaffCummunicationService } from '../../hr/staff-cummunication.service';
import { StatisticsDropdownComponent } from './statistics-dropdown/statistics-dropdown.component';
import { SharedDataService } from '../shared.data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { HelperService } from 'src/app/services/helper.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { ScreenshotService } from '../global-screenshot/screenshot.service';
import { RealtimeSessionService } from '../../../services/realtime/realtime-session.service';
import {
  UserStatusService,
  StatusInfo,
} from './statistics-dropdown/user-status.service';
import { NotificationService } from 'src/app/services/core/notification/notification.service';
import { StaffChangePasswordComponent } from '../../hr/staff-detail-page/parts/staff-change-password/staff-change-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RemindersService } from '../reminders/services/reminders.service';
import { HeaderEmailSidebarService, IQuickEmail } from './header-email-sidebar/header-email-sidebar.service';
import { MatDialog } from '@angular/material/dialog';
import { ComposeEmailComponent } from '../../email/compose-email/compose-email.component';
import { HrDataService } from '../../hr/hr.service';
import { BackendApiService } from 'src/app/services/backend-api.service';
import { UserActivityService } from '../user-activity.service';
import { PTORequestDialogComponent, PTORequestDialogData, PTORequestDialogResult } from '../../hr/staff-detail-page/parts/pto-request-dialog/pto-request-dialog.component';
import { PTOApprovalQueueDialogComponent, PTOApprovalQueueDialogData } from './pto-approval-queue-dialog/pto-approval-queue-dialog.component';
import { ClockInService } from '../clock-in.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @Output() refreshMainComponet = new EventEmitter<boolean>();
  @ViewChild('menu') menu!: MatMenuTrigger;
  @ViewChild('notificationScroll') notificationScroll!: ElementRef;
  @ViewChild('notificationMenuTrigger') notificationMenuTrigger!: MatMenuTrigger;
  @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger;
  @ViewChild('notificationMarkAllAsReadMenu')
  notificationMarkAllAsReadMenu!: MatMenuTrigger;
  @ViewChild('notificationMarkAsUnReadMenu')
  notificationMarkAsUnReadMenu!: MatMenuTrigger;

  public user: any;
  public isSideBarOpen: boolean = false;
  public userDetail: any = null;
  public companyListSelection: any = [];
  public groupOffices: any = [];
  NotificationList: any = [];
  NotificationMeta: any = [];
  currentCompanyId: any = 0;
  regularUnreadCount: number = 0;
  watchFocusUnreadCount: number = 0;
  watchRegularUnreadCount: number = 0;
  watchUnreadCount: number = 0;
  selectedNotificationId: number | null = null;
  allowedRoutes: string[] = [
    '/customers',
    '/contacts',
    '/bids',
    '/proposals',
    '/jobs',
    '/submittals',
    '/change-orders',
    '/tasks',
    '/tickets',
    '/notes',
    '/hr',
    '/settings',
    '/customers',
    '/vendors',
    '/warehouses',
    '/jobsites',
    '/products',
    '/services',
    '/subcontractors',
    '/categories/product',
    '/dashboard',
    '/document'
  ];

  showOfficePanel = false;
  public lastSelectedOffices: any = [];
  public isSettingChange = false;
  public userId: any;
  dropdownItems: any = [];
  public userStaffDetail: any;
  private readonly debounceTimeMs = 500;
  param = { per_page: 10, page: 1 };
  showLoadMoreOption: boolean = false;
  isLoading: boolean = false;
  isRequestInProgress: boolean = false;
  isLogoutInProgress: boolean = false;

  isResetInProgress: boolean = false;
  currentFilterType: string = 'regular';
  currentFocusTab: string = 'regular';
  showOnlyUnread: boolean = false;
  currentNotificationCount: any = null;

  // Activity Panel
  showActivityPanel = false;

  // Reminders Panel
  showRemindersPanel = false;

  // Buddy glance popover (4b)
  showBuddyGlance = false;
  // Master toggle for the Buddy assistant UI (default false — hidden).
  enableBuddyFeatures: boolean = (environment as any)?.enableBuddyFeatures === true;
  reminderUnreadCount$!: Observable<number>;
  hasUrgentReminders$!: Observable<boolean>;

  // Email Sidebar
  showEmailSidebar = false;
  emailUnreadCount$!: Observable<number>;
  //service work start
  currentStatus: any = null;
  currentStatusInfo: StatusInfo | null = null;
  public statusSubscription: Subscription | null = null;
  private counterSubscription: Subscription | null = null;
  private alertModalSubscription: Subscription | null = null;
  private currentOpenMenuTrigger: MatMenuTrigger | null = null;

  //service work end

  // Clock In/Out state
  isCurrentlyClockedIn: boolean = false;
  isClockingInOut: boolean = false;
  private clockUpdateInterval: any;
  private clockInServiceSubscription: Subscription | null = null;

  // Time Off Settings - populated from API for PTO Request Dialog
  timeOffSettings: any = {
    vacation_days: 0,
    sick_days: 0,
    personal_days: 0,
    yearly_vacation_days: 0
  };

  constructor(
    private currentUser: UserService,
    private router: Router,
    private authDataService: AuthDataService,
    public dialog: NgDialogAnimationService,
    private matDialog: MatDialog,
    private element: ElementRef,
    private jsonService: JsonService,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private staffCommunicationService: StaffCummunicationService,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    public toasterService: ToasterService,
    private userStatusService: UserStatusService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private remindersService: RemindersService,
    private headerEmailSidebarService: HeaderEmailSidebarService,
    private hrDataService: HrDataService,
    private backendApiService: BackendApiService,
    private userActivityService: UserActivityService,
    private clockInService: ClockInService,
    @Inject(DOCUMENT) private document: Document,
    private screenshotService: ScreenshotService,
    private realtimeSession: RealtimeSessionService
  ) {
    this.reminderUnreadCount$ = this.remindersService.unreadCount$;
    this.hasUrgentReminders$ = this.remindersService.urgentReminders$;
    this.emailUnreadCount$ = this.headerEmailSidebarService.unreadCount$;
  }

  ngOnInit(): void {
    this.user = this.currentUser;
    this.getUserDetail();
    this.userId = this.user.getID();
    this.dropDownList();
    this.fetchTimeOffSettings(); // Fetch Time Off Settings for PTO Request Dialog
    this.userActivityService.startTracking(); // Start tracking user activity

    // Load the screenshot engine + inline fonts while idle, so the first
    // capture is as fast as the rest (~50ms instead of ~1.5s).
    this.warmScreenshotEngine();

    // Auto-migrate localStorage reminders to backend (one-time)
    this.checkAndMigrateReminders();

    // Close reminder panel when alert modal opens
    this.alertModalSubscription = this.remindersService.alertModalOpen$.subscribe(() => {
      this.closeRemindersPanel();
    });

    this.userStaffDetail = this.user.getUserStaffDetail();
    this.staffCommunicationService
      .getStaffCommunication()
      .subscribe((res: any) => {
        if (res?.id == this.userId) {
          this.user.setUserStaffDetail(res?.staff_detail);
          this.userStaffDetail = this.user.getUserStaffDetail();
        }
      });

    this.getCurrentNotificationCount();

    this.getUserCurrentStatus();
    this.notificationService.notificationClicked$.subscribe((payload) => {
      this.handleNotificationClick(payload);
    });

    // Initialize clock in/out status
    this.getClockStatus();

    // Subscribe to clock-in service for real-time updates from other components
    this.subscribeToClockInUpdates();
  }

  handleNotificationClick(payload: any): void {
    this.resetNotificationCounter();
    this.getNotification(true, this.currentFilterType);
    setTimeout(() => {
      if (this.notificationMenuTrigger) {
        this.notificationMenuTrigger.openMenu();
      }
    }, 100);
  }

  getCurrentNotificationCount() {
    this.counterSubscription =
      this.notificationService.notificationCounter$.subscribe(
        (counter: any) => {
          this.currentNotificationCount = parseInt(counter); // Update the counter
        }
      );
  }

  getUserCurrentStatus() {
    this.currentStatus = this.currentUser.getUserStatus();
    this.statusSubscription = this.userStatusService.status$.subscribe(
      (statusInfo) => {
        if (statusInfo) {
          this.currentStatusInfo = statusInfo;
          this.currentStatus = this.currentStatusInfo?.slug;
        }
      }
    );
  }

  getNotification(isFirstInitialized?: any, filterType?: string): void {
    if (this.isRequestInProgress) return;
    this.isRequestInProgress = true;
    this.isLoading = true;

    isFirstInitialized ? (this.param = { per_page: 10, page: 1 }) : null;

    const params: any = {
      sort_by: 'id',
      sort_order: 'DESC',
      per_page: this.param.per_page,
      page: this.param.page,
      loadingService: 0,
      type: filterType || this.currentFilterType,
    };
    if (this.showOnlyUnread) {
      params.is_unread = 1;
    }
    if (
      (filterType || this.currentFilterType) === 'watch' &&
      this.currentFocusTab
    ) {
      params.watch_type =
        this.currentFocusTab === 'regular' ? 'watch' : 'focus_watch';
    }

    this.sharedDataService
      .getNotification(params)
      .pipe(first())
      .subscribe((res: any) => {
        this.NotificationList = isFirstInitialized
          ? [...res?.data]
          : [...this.NotificationList, ...res?.data];
        this.NotificationMeta = res?.meta;

        this.regularUnreadCount = res?.regular_unread_count || 0;
        this.watchUnreadCount = res?.watch_unread_count || 0;
        this.watchFocusUnreadCount = res?.watch__focus_unread_count;
        this.watchRegularUnreadCount = res?.watch_regula_unread_count;
        this.updateLoadMoreOption();
        this.isRequestInProgress = false;
        this.isLoading = false;
      });
  }

  onFilterChange(event: any): void {
    const newFilterType = event.value;
    if (newFilterType !== this.currentFilterType) {
      this.currentFilterType = newFilterType;
      this.NotificationList = [];
      this.getNotification(true, this.currentFilterType);
    }
  }

  onFocusTabChange(event: any): void {
    this.currentFocusTab = event.value;
    this.NotificationList = []; // Clear current list

    const params: any = {
      sort_by: 'id',
      sort_order: 'DESC',
      per_page: 10,
      page: 1,
      loadingService: 0,
      type: 'watch',
      watch_type: this.currentFocusTab === 'regular' ? 'watch' : 'focus_watch',
    };

    // Add is_unread parameter if showOnlyUnread is true
    if (this.showOnlyUnread) {
      params.is_unread = 1;
    }

    this.isRequestInProgress = true;
    this.isLoading = true;

    this.sharedDataService
      .getNotification(params)
      .pipe(first())
      .subscribe((res: any) => {
        this.NotificationList = [...res?.data];
        this.NotificationMeta = res?.meta;
        this.updateLoadMoreOption();
        this.isRequestInProgress = false;
        this.isLoading = false;
      });
  }

  onResetFilter(): void {
    this.NotificationList = [];
    this.param = { per_page: 10, page: 1 };

    const params: any = {
      sort_by: 'id',
      sort_order: 'DESC',
      per_page: 10,
      page: 1,
      loadingService: 0,
      type: 'watch',
    };

    this.isRequestInProgress = true;
    this.isLoading = true;
    this.showOnlyUnread = false;
    this.sharedDataService
      .getNotification(params)
      .pipe(first())
      .subscribe((res: any) => {
        this.NotificationList = [...res?.data];
        this.NotificationMeta = res?.meta;
        this.updateLoadMoreOption();
        this.isRequestInProgress = false;
        this.isLoading = false;
      });
  }

  onMarkAsSeenClick(notificationId: number, event: any): void {
    event.stopPropagation();
    const notification = this.NotificationList.find(
      (n: any) => n.id === notificationId
    );
    if (notification) {
      notification.is_seen = 1;
    }

    this.sharedDataService
      .createMarkAsSeen(notificationId)
      .subscribe((res: any) => {
        this.toasterService.showSuccessMessage(res?.message);
        this.getNotification(true, this.currentFilterType);
      });
  }

  notificationMarkAllAsRead(event: Event): void {
    event.stopPropagation();
    this.notificationMarkAllAsReadMenu.closeMenu();
    this.sharedDataService
      .creareNotificationMarkAllRead()
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          if (this.NotificationList && this.NotificationList.length > 0) {
            this.NotificationList.forEach((notification: any) => {
              notification.is_seen = 1;
            });
          }
          this.currentNotificationCount = 0;
          this.regularUnreadCount = 0;
          this.watchUnreadCount = 0;

          this.toasterService.showSuccessMessage(response?.message);
        },
      });
  }

  setSelectedNotificationId(notificationId: number): void {
    this.selectedNotificationId = notificationId;
  }

  onNotificationRightClick(
    event: MouseEvent,
    item: any,
    trigger: MatMenuTrigger
  ) {
    event.preventDefault();
    event.stopPropagation();

    if (item.is_seen == 1) {
      // Close any previously open menu
      if (
        this.currentOpenMenuTrigger &&
        this.currentOpenMenuTrigger !== trigger
      ) {
        this.currentOpenMenuTrigger.closeMenu();
      }

      this.setSelectedNotificationId(item.id);
      this.currentOpenMenuTrigger = trigger;
      trigger.openMenu();
    }
  }

  notificationMarkAsUnseen(event: Event): void {
    event.stopPropagation();

    // Close the current menu
    if (this.currentOpenMenuTrigger) {
      this.currentOpenMenuTrigger.closeMenu();
      this.currentOpenMenuTrigger = null;
    }

    if (this.selectedNotificationId) {
      const notification = this.NotificationList.find(
        (n: any) => n.id === this.selectedNotificationId
      );
      if (notification) {
        notification.is_seen = 0;
      }
      this.sharedDataService
        .createMarkAsUnseen(this.selectedNotificationId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            this.toasterService.showSuccessMessage(response?.message);
            this.getNotification(true, this.currentFilterType);
          },
        });
      this.selectedNotificationId = null;
    }
  }

  /**
   * Handle notification click - navigate to the notification target
   * @param notification The clicked notification
   * @param event The click event
   */
  onNotificationClick(notification: any, event: Event): void {
    // Don't navigate on right-click (context menu)
    if (event && (event as MouseEvent).button === 2) {
      return;
    }

    event?.stopPropagation();

    console.log('🖱️ [HeaderComponent] Notification clicked', {
      notification: notification,
      notification_id: notification.id,
      meta_data: notification.meta_data,
      meta_data_type: typeof notification.meta_data,
      title: notification.title,
      message: notification.message,
      notification_action: notification.notification_action,
      module_id: notification.module_id,
      reference_id: notification.reference_id
    });

    // Use the notification service to handle navigation
    this.notificationService.handleInAppNotificationClick(notification);

    // Close the notification menu
    if (this.notificationMenuTrigger) {
      this.notificationMenuTrigger.closeMenu();
    }
  }

  onNotificationMenuClosed(): void {
    this.currentOpenMenuTrigger = null;
  }

  onUnreadToggleChange(event: any): void {
    this.showOnlyUnread = event.checked;
    this.NotificationList = [];
    this.getNotification(true, this.currentFilterType);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onScroll();
    }, 3000);
  }

  loadMoreData(): void {
    if (this.isRequestInProgress) return;
    if (
      this.NotificationMeta.total === this.NotificationMeta.to ||
      this.NotificationMeta.last_page < this.NotificationMeta.current_page
    ) {
      return;
    }
    this.param.page += 1;
    this.updateLoadMoreOption();
    if (this.showLoadMoreOption) {
      // this.getNotification();
      this.getNotification(false, this.currentFilterType);
    }
  }

  onScroll(): void {
    const scrollElement = this.notificationScroll?.nativeElement;
    if (scrollElement) {
      const threshold = 25;
      const position = scrollElement.scrollTop + scrollElement.offsetHeight;
      const height = scrollElement.scrollHeight;

      if (position > height - threshold && this.showLoadMoreOption) {
        this.loadMoreData();
      }
    }
  }

  resetNotificationCounter(): void {
    if (this.isResetInProgress) {
      return; // Skip if reset is already in progress or badge is already hidden
    }
    this.isResetInProgress = true;

    this.sharedDataService
      .NotificationResetCounter({})
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.currentNotificationCount = 0;
            this.isResetInProgress = false;
          }
        },
      });
  }

  private updateLoadMoreOption(): void {
    this.showLoadMoreOption =
      this.helperService.checkActivityLogLoadMoreOptionVisibility(
        this.NotificationList,
        this.NotificationMeta
      );
  }

  getUserDetail() {
    this.authDataService.getAuthUserDetail().subscribe((data) => {
      localStorage.setItem(
        'auth_detail',
        this.jsonService.doStringify(data.data.data)
      );
      this.userDetail = data.data.data;
      this.currentUser.setNotificationCount(
        this.userDetail?.total_notification_count
      );

      this.groupOffices = this.groupCompanies(this.userDetail.attach_tenents);
      this.lastSelectedOffices = this.userDetail.selected_tenents?.map(
        (tenant: any) => tenant?.id
      );

      this.userDetail.attach_tenents.forEach((element: any) => {
        this.companyListSelection.push({
          name: element.name,
          value: element.id,
          selected: this.lastSelectedOffices.includes(element.id),
        });
      });

      this.currentCompanyId = this.userDetail.current_tenent.id;
      this.getUserNotificationCount();
    });
  }

  getUserNotificationCount() {
    this.currentNotificationCount = this.currentUser.getNotificationCount();
  }

  onOfficeSettingApply() {
    let data = {
      select_tenents: this.lastSelectedOffices,
      current_tenent: this.currentCompanyId,
    };

    this.authDataService
      .setAuthUserOfficeSetting(data)
      .pipe(first())
      .subscribe((data: any) => {
        this.authDataService.getAuthUserDetail().subscribe((data) => {
          const currentRoute = this.router.url;
          if (
            this.allowedRoutes.some((route) => currentRoute.includes(route))
          ) {
            this.refreshMainComponet.emit(true);
          }
          localStorage.setItem(
            'auth_detail',
            this.jsonService.doStringify(data.data.data)
          );

          // Switching office can change the family root, which is the node the
          // Signal Bus (and permission sync) listens on. Re-point it, or the
          // session would keep listening to the previous office's signals.
          const authDetail = data?.data?.data;
          this.realtimeSession.start(
            authDetail?.family_root_id,
            authDetail?.id,
            authDetail?.signal_namespace
          );

          this.closeOfficePanel();
        });
      });
  }

  getSelectedCompanyName(): string {
    const selectedCompany = this.companyListSelection.find(
      (tenant: any) => tenant.value == this.currentCompanyId
    );
    return selectedCompany ? selectedCompany.name : 'Select Office';
  }

  onMobileToggaleSideBarOpen = () => {
    this.document.body.classList.add('sidebar-open');
  };

  onToggaleSideBar = () => {
    if (this.isSideBarOpen) {
      this.document.body.classList.remove('sidebar-pinned');
      this.isSideBarOpen = false;
    } else {
      this.document.body.classList.add('sidebar-pinned');
      this.isSideBarOpen = true;
    }
  };

  onLogout() {
    if (this.isLogoutInProgress) {
      return;
    }
    this.isLogoutInProgress = true;
    this.authDataService
      .onLogout({})
      .pipe(
        first(),
        finalize(() => {
          this.isLogoutInProgress = false;
        })
      )
      .subscribe({
        next: (data) => {
          // Dialogs are attached to the CDK overlay container on document.body,
          // not under <router-outlet>, so the redirect below would leave them
          // open over the login page.
          this.dialogService.closeAll();
          this.currentUser.flushAll();
          this.router.navigateByUrl('/auth/login');
        },
        error: (error) => {
          console.error('Logout failed:', error);
        },
      });
  }

  ChangePassword(): void {
    // Use the staff change password dialog method for proper centering
    this.dialogService.onOpenStaffChangePassPopUpDialog(ChangePasswordComponent,
          { userData: this.userId }
        );
  }

  /**
   * Open 2FA settings dialog for enable/disable management.
   */
  openTwoFactorSettings(): void {
    import('../two-factor-settings/two-factor-settings.component').then(m => {
      this.matDialog.open(m.TwoFactorSettingsComponent, {
        width: '500px',
        disableClose: false,
        autoFocus: false,
        panelClass: 'two-factor-settings-dialog-container',
      });
    });
  }

  sanitizeSVG(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  toggleOfficePanel(): void {
    if (this.companyListSelection.length <= 1) {
      return;
    }
    this.getUserDetail();
    this.showOfficePanel = !this.showOfficePanel;
  }

  closeOfficePanel(): void {
    if (this.isSettingChange) {
      this.onOfficeSettingApply();
    }
    this.isSettingChange = false;
    this.showOfficePanel = false;
  }

  toggleRemindersPanel(): void {
    this.showRemindersPanel = !this.showRemindersPanel;
    if (this.showRemindersPanel) {
      this.showActivityPanel = false;
    }
  }

  closeRemindersPanel(): void {
    this.showRemindersPanel = false;
  }

  // ==================== EMAIL SIDEBAR METHODS ====================

  toggleEmailSidebar(): void {
    this.showEmailSidebar = !this.showEmailSidebar;
    // Close reminders panel when opening email sidebar
    if (this.showEmailSidebar) {
      this.showRemindersPanel = false;
    }
  }

  /** Camera icon in the header — delegates to the global screenshot service. */
  startScreenshot(): void {
    this.screenshotService.startCapture();
  }

  /** Preload the screenshot engine off the critical path. */
  private warmScreenshotEngine(): void {
    const warm = () => this.screenshotService.warmUp();
    const idle = (window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    }).requestIdleCallback;

    if (idle) {
      idle(warm, { timeout: 5000 });
    } else {
      setTimeout(warm, 3000); // Safari
    }
  }

  closeEmailSidebar(): void {
    this.showEmailSidebar = false;
  }

  onEmailItemClick(email: IQuickEmail): void {
    // Email is now viewed in sidebar reading pane
    // This handler can be used for tracking/analytics
    console.log('Email viewed:', email.id);
  }

  toggleActivityPanel(): void {
    this.showActivityPanel = !this.showActivityPanel;
    if (this.showActivityPanel) {
      this.showRemindersPanel = false;
    }
  }

  closeActivityPanel(): void {
    this.showActivityPanel = false;
  }

  toggleBuddyGlance(): void {
    this.showBuddyGlance = !this.showBuddyGlance;
    // Only one header popover at a time.
    if (this.showBuddyGlance) {
      this.showActivityPanel = false;
      this.showRemindersPanel = false;
    }
  }

  closeBuddyGlance(): void {
    this.showBuddyGlance = false;
  }

  /**
   * Check and auto-migrate localStorage reminders to backend (one-time)
   */
  private checkAndMigrateReminders(): void {
    if (this.remindersService.needsMigration()) {
      console.log('Migrating reminders to backend...');

      this.remindersService.migrateToBackend().subscribe({
        next: () => {
          console.log('Reminders migrated successfully');
          this.toasterService.showSuccess('Your reminders have been synced to the cloud!');
        },
        error: (error) => {
          console.error('Migration failed:', error);
          // Silent fail - user can still use the system
        }
      });
    }
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this.element.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.closeOfficePanel();
    }
  }

  selectOffice(id: any) {
    this.isSettingChange = true;
    if (this.lastSelectedOffices.length === 0) {
      this.lastSelectedOffices.push(id);
    } else {
      const firstItemId = this.lastSelectedOffices[0];
      const firstOption = this.userDetail.attach_tenents.find(
        (tenant: any) => tenant.id === firstItemId
      );

      const isInSelectedOptions = firstOption.selected_options?.includes(id);
      if (isInSelectedOptions) {
        if (this.lastSelectedOffices.includes(id)) {
          if (id != this.currentCompanyId) {
            this.lastSelectedOffices = this.lastSelectedOffices.filter(
              (item: any) => item !== id
            );
          }
        } else {
          this.lastSelectedOffices.push(id);
        }
      } else {
        this.snackBar.open(
          'The last selected office is of a different type, so your previously selected offices have been deselected.',
          '',
          {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          }
        );
        this.lastSelectedOffices = [id];
        this.currentCompanyId = id;
      }
    }
  }

  setDefaultOffice(id: any) {
    this.isSettingChange = true;
    if (this.lastSelectedOffices.length === 0) {
      this.lastSelectedOffices.push(id);
      this.currentCompanyId = id;
    } else {
      const firstItemId = this.lastSelectedOffices[0];
      const firstOption = this.userDetail.attach_tenents.find(
        (tenant: any) => tenant.id === firstItemId
      );

      const isInSelectedOptions = firstOption.selected_options?.includes(id);
      if (isInSelectedOptions) {
        if (this.lastSelectedOffices.includes(id)) {
          this.currentCompanyId = id;
          // this.lastSelectedOffices = this.lastSelectedOffices.filter((item:any) => item !== id);
        } else {
          this.lastSelectedOffices.push(id);
          this.currentCompanyId = id;
        }
      } else {
        this.snackBar.open(
          'The last selected office is of a different type, so your previously selected offices have been deselected.',
          '',
          {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          }
        );
        this.lastSelectedOffices = [id];
        this.currentCompanyId = id;
      }
    }
  }

  getOfficesListTooltip(id: any): string {
    const option = this.userDetail.attach_tenents.find(
      (tenant: any) => tenant.id === id
    );
    const optionSelection = this.userDetail.attach_tenents?.filter(
      (tenant: any) => option.selected_options.includes(tenant.id)
    );
    const optionSelectionName = optionSelection?.map(
      (tenant: any) => tenant.name
    );
    if (optionSelectionName && optionSelectionName.length > 0) {
      return `You have chosen to select these office:\n${optionSelectionName.join(
        ', '
      )}`;
    }
    return '';
  }

  groupCompanies(data: any[]): any[] {
    const result: any[] = [];
    const companyMap = new Map<number, any>();
    const missingParentIds = new Set<number>();

    data.forEach((company) => companyMap.set(company.id, company));
    // Identify missing parents (children whose parent doesn't exist)
    data.forEach((company) => {
      if (!companyMap.has(company.tenant_id) && company.tenant_id != null) {
        missingParentIds.add(company.tenant_id); // Mark the missing parent
      }
    });

    // Add a dummy parent for each missing parent ID (only once)
    missingParentIds.forEach((missingId: any) => {
      data.push({
        id: missingId, // Use the missing parent ID as a unique identifier
        name: 'Unassigned Company',
        unassigned: true,
        is_parent: true,
        selected_options: [],
        children: [],
      });
    });

    // Recursive function to find and nest children
    const findChildren = (parentId: number, visited: Set<number>): any[] => {
      if (visited.has(parentId)) return []; // Prevent circular references
      visited.add(parentId);

      const children = data.filter(
        (company) =>
          company.selected_options.includes(parentId) && company.id !== parentId
      );

      if (children.length === 0) return []; // Base case: no more children

      return children.map((child) => ({
        ...child,
        is_parent: false,
        children: findChildren(child.id, new Set(visited)), // Recursively find children
      }));
    };

    // Find parents and nest their children
    data.forEach((company) => {
      if (company.is_parent) {
        result.push({
          ...company,
          children: findChildren(company.id, new Set()),
        });
      }
    });

    return this.clearChildrenIfNotParent(result);
  }

  clearChildrenIfNotParent(data: any[]): any[] {
    data.forEach((item) => {
      if (!item.is_parent) {
        item.children = []; // Empty the children array if is_parent is false
      } else if (item.children && item.children.length > 0) {
        this.clearChildrenIfNotParent(item.children); // Recurse for nested children
      }
    });
    return data;
  }

  getInitials(fullName: string): string {
    return (
      fullName
        ?.trim()
        .split(/\s+/) // Split by any whitespace (handles multiple spaces)
        .slice(0, 2) // Take only the first two words
        .map((word) => word[0]?.toUpperCase()) // Get the first letter in uppercase
        .join('') || ''
    ); // Join letters and return empty string if no name
  }

  onMenuItemClick(action: () => void, event: Event) {
    event.stopPropagation();

    if (action.toString().includes('onLogout') && this.isLogoutInProgress) {
      return;
    }

    action();
  }

  onMenuClosed() {
    // This ensures the menu does not auto-close when clicking inside
  }

  ngOnDestroy(): void {
    if (this.statusSubscription) {
      this.statusSubscription?.unsubscribe();
    }
    if (this.counterSubscription) {
      this.counterSubscription.unsubscribe();
    }
    if (this.alertModalSubscription) {
      this.alertModalSubscription.unsubscribe();
    }
    if (this.clockInServiceSubscription) {
      this.clockInServiceSubscription.unsubscribe();
    }
    if (this.clockUpdateInterval) {
      clearInterval(this.clockUpdateInterval);
    }
    // Stop user activity tracking and clean up listeners
    this.userActivityService.stopTracking();
  }

  dropDownList() {
    this.dropdownItems = [
      {
        title: 'Change Password',
        iconName: 'lock_reset',
        action: () => {
          this.ChangePassword();
        },
      },
      {
        title: 'Two-Factor Auth',
        iconName: 'security',
        action: () => {
          this.openTwoFactorSettings();
        },
      },
      {
        title: 'Logout',
        iconName: 'logout',
        action: () => {
          this.onLogout();
        },
      },
    ];
  }

  // ========== CLOCK IN/OUT METHODS ==========

  /**
   * Subscribe to clock-in service for real-time updates from other components
   * This ensures header badge updates when clock status changes from staff-detail-page
   */
  private subscribeToClockInUpdates(): void {
    const loginUserId = this.currentUser.getID();
    if (!loginUserId) return;

    this.clockInServiceSubscription = this.clockInService.clockStatus$.subscribe(
      (clockStatus) => {
        if (clockStatus && clockStatus.staff_id === parseInt(loginUserId, 10)) {
          // Update header badge when clock status changes from other components
          this.isCurrentlyClockedIn = clockStatus.is_clocked_in;
          console.log('Header clock status updated from service:', clockStatus);
        }
      }
    );
  }

  /**
   * Get clock in/out status from backend for logged-in user
   */
  getClockStatus(): void {
    const loginUserId = this.currentUser.getID();
    if (!loginUserId) return;

    this.hrDataService.getStaffClockStatus(loginUserId)
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          const clockData = response?.data?.data;

          if (clockData) {
            this.isCurrentlyClockedIn = clockData.is_clocked_in === true;
          }
        },
        error: (error: any) => {
          console.error('Failed to fetch clock status:', error);
          // Default to clocked out state on error
          this.isCurrentlyClockedIn = false;
        }
      });
  }

  /**
   * Toggle clock in/out for logged-in user
   * Uses optimistic UI updates for instant feedback
   */
  toggleClock(): void {
    const loginUserId = this.currentUser.getID();

    if (!loginUserId) {
      this.toasterService.showError('Error', 'User information not available');
      return;
    }

    // Prevent double-click
    if (this.isClockingInOut) {
      return;
    }

    this.isClockingInOut = true;

    // Store previous state for rollback on error
    const previousState = this.isCurrentlyClockedIn;

    if (this.isCurrentlyClockedIn) {
      // ========== CLOCK OUT ==========

      // Optimistic UI update - update UI immediately before API call
      this.isCurrentlyClockedIn = false;

      // Broadcast optimistic update to all subscribers immediately
      this.clockInService.updateClockStatus({
        is_clocked_in: false,
        clock_in: null,
        staff_id: parseInt(loginUserId, 10)
      });

      // Make API call
      this.hrDataService.clockOut(loginUserId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            // API success - show success message
            this.toasterService.showSuccessMessage(
              response?.data?.message 
            );
            this.isClockingInOut = false;
          },
          error: (error: any) => {
            console.error('Clock out failed:', error);

            // Rollback optimistic update on error
            this.isCurrentlyClockedIn = previousState;

            this.clockInService.updateClockStatus({
              is_clocked_in: previousState,
              clock_in: previousState ? new Date() : null,
              staff_id: parseInt(loginUserId, 10)
            });

            // this.toasterService.showError(
            //   'Error',
            //   error?.error?.message || 'Failed to clock out'
            // );
            this.isClockingInOut = false;
          }
        });
    } else {
      // ========== CLOCK IN ==========

      // Optimistic UI update - update UI immediately before API call
      this.isCurrentlyClockedIn = true;
      const optimisticClockInTime = new Date();

      // Broadcast optimistic update to all subscribers immediately
      this.clockInService.updateClockStatus({
        is_clocked_in: true,
        clock_in: optimisticClockInTime,
        staff_id: parseInt(loginUserId, 10)
      });

      // Make API call
      this.hrDataService.clockIn(loginUserId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            // API success - update with actual clock in time from server
            const actualClockInTime = response?.data?.data?.clock_in || optimisticClockInTime;

            this.clockInService.updateClockStatus({
              is_clocked_in: true,
              clock_in: actualClockInTime,
              staff_id: parseInt(loginUserId, 10)
            });

            this.toasterService.showSuccessMessage(
              response?.data?.message 
            );
            this.isClockingInOut = false;
          },
          error: (error: any) => {
            console.error('Clock in failed:', error);

            // Rollback optimistic update on error
            this.isCurrentlyClockedIn = previousState;

            this.clockInService.updateClockStatus({
              is_clocked_in: previousState,
              clock_in: null,
              staff_id: parseInt(loginUserId, 10)
            });

            // this.toasterService.showError(
            //   'Error',
            //   error?.error?.message || 'Failed to clock in'
            // );
            this.isClockingInOut = false;
          }
        });
    }
  }

  /**
   * Fetch Time Off Settings from API
   * GET /api/v1/time-off-settings
   * Populates timeOffSettings for use in PTO Request Dialog
   */
  fetchTimeOffSettings(): void {
    this.backendApiService.getApi('time-off-settings')
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          const settings = response?.data?.data;
          if (settings) {
            this.timeOffSettings = {
              vacation_days: settings.vacation_days || 0,
              sick_days: settings.sick_days || 0,
              personal_days: settings.personal_days || 0,
              yearly_vacation_days: settings.yearly_vacation_days || 0
            };
            console.log('Time Off Settings loaded in header:', this.timeOffSettings);
          }
        },
        error: (error) => {
          console.error('Failed to load Time Off Settings in header:', error);
          // Keep default values (0s)
        }
      });
  }

  /**
   * Open PTO Request Dialog for logged-in user
   */
  openPTORequestDialog(): void {
    const loginUserId = this.currentUser.getID();
    const userFullName = this.currentUser.getFullName();

    if (!loginUserId) {
      this.toasterService.showError('Error', 'User information not available');
      return;
    }

    // Convert loginUserId to number
    const staffId = parseInt(loginUserId, 10);

    // Open the PTO Request dialog with logged-in user ID and Time Off Settings from API
    const dialogRef = this.dialog.open(PTORequestDialogComponent, {
      width: '680px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      autoFocus: true,
      data: {
        staffId: staffId,
        staffName: userFullName || 'User',
        ptoBalance: {
          // Use Time Off Settings API values (fetched in fetchTimeOffSettings)
          vacation_days: this.timeOffSettings.vacation_days || 0,
          vacation_total: this.timeOffSettings.vacation_days || 0,
          sick_days: this.timeOffSettings.sick_days || 0,
          sick_total: this.timeOffSettings.sick_days || 0,
          personal_days: this.timeOffSettings.personal_days || 0,
          personal_total: this.timeOffSettings.personal_days || 0
        }
      } as PTORequestDialogData
    });

    dialogRef.afterClosed().subscribe((result: PTORequestDialogResult) => {
      if (result) {
        this.submitPTORequest(result, staffId);
      }
    });
  }

  /**
   * Submit PTO request for logged-in user
   */
  submitPTORequest(request: PTORequestDialogResult, staffId: number): void {
    // Prepare API payload
    const payload = {
      staff_id: staffId,
      time_off_type: request.type.toLowerCase().replace(' ', '_'),
      start_date: request.start_date,
      end_date: request.end_date,
      notes: request.notes || '',
      // ids of files already uploaded (dialog uploads them as they're added
      // via the existing generic attachments endpoint) — linked server-side.
      file_ids: request.file_ids || []
    };

    // Call API to create time off request
    this.hrDataService.createTimeOffRequest(payload)
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          this.toasterService.showSuccessMessage(response?.data?.message);
        },
        error: (error: any) => {
          console.error('Failed to create time off request:', error);
          // this.toasterService.showError('Error', 'Failed to submit time off request');
        }
      });
  }

  /**
   * Open PTO Approval Queue Dialog for logged-in user
   */
  openPTOApprovalQueueDialog(): void {
    const loginUserId = this.currentUser.getID();
    const userFullName = this.currentUser.getFullName();

    if (!loginUserId) {
      this.toasterService.showError('Error', 'User information not available');
      return;
    }

    // Convert loginUserId to number
    const staffId = parseInt(loginUserId, 10);

    // Open the PTO Approval Queue dialog with logged-in user ID
    const dialogRef = this.dialog.open(PTOApprovalQueueDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: false,
      autoFocus: false,
      data: {
        staffId: staffId,
        staffName: userFullName || 'User'
      } as PTOApprovalQueueDialogData
    });

    // Optional: Refresh data after dialog closes if needed
    dialogRef.afterClosed().subscribe((result: any) => {
      // Handle any actions after dialog closes if needed
    });
  }
}
